import { observable, action } from "mobx";
import { ROUTE_PROFILAZIONE , ROUTE_FERMO, ROUTE_RESTITUZIONE_DUPLO, ROUTE_HOME, ROUTE_FROM_UNIMODWEB } from "../assets/frontendRouting";
import { isFromPegni, isFromUnimodweb , isFromUnimodwebBB, isFromRicevuteDuplo, isFromRestituzioneDuplo,isFromPegniCertificati, isFromCancellazioniIpoteca} from "../assets/utils/queryParams";
import {PATH_INFO_USER} from '../config/portale-config'
import { PATH_TRAMISSIONE_PEGNO_QUALIFICA_RICHIEDENTE, PATH_TRAMISSIONE_DUPLO_QUALIFICA_RICHIEDENTE, PATH_TRAMISSIONE_UNIMOD_QUALIFICA_RICHIEDENTE, PATH_TRAMISSIONE_PEGNO_CERT_QUALIFICA_RICHIEDENTE, PATH_TRAMISSIONE_COM_CANC_QUALIFICA_RICHIEDENTE } from "../config/presdoc-fe-config";

class QualificheStore {

  constructor(root) {
    this.service = root.service
    this.rootStore = root;
    this.routingStore = root.routingStore;
    //this.fermoStore = root.fermoStore;
  }

 // @observable qualificaCittadino = 34;
  @observable qualifiche = undefined;
  @observable qualifica = undefined;
  @observable utenzaDiLavoroErrataFlag = false;
  @observable initialPath = undefined;
  @observable tipoPratica = undefined;
  @observable esitoContestuale = false;

  @action setEsitoContestuale (esitoContestuale) {
    this.esitoContestuale = esitoContestuale
  }
  @action
  fetchQualifiche(redirectPath, callback) {
    //salvo il path iniziale in cui l'utente voleva atterrare. Questo path verra' riutilizzato alla selezione di una qualifica.
    this.initialPath = redirectPath;
    //effettuo la chiamata rest corretta
    // le qualifiche, in caso di unimodweb, possono essere selezionate. Quindi il redirectPath potrebbe essere undefined.
    // se undefined, non verra' effettuata la redirect successivamente alla selezione.
    if (isFromPegni(redirectPath)) {      
      this.tipoPratica = 'MP'
      this.esitoContestuale = false
      this.fetchQualifichePegni(callback);
    }else if(isFromRestituzioneDuplo(redirectPath) || isFromRicevuteDuplo(redirectPath) ){
      this.tipoPratica = 'UN'
      this.esitoContestuale = false
      this.fetchQualificheDuplo(callback);
    }
    else if(isFromUnimodwebBB(redirectPath)  ){
      this.tipoPratica = 'UN'
      this.esitoContestuale = true
      console.log("esitoContestuale: "+ JSON.stringify(this.esitoContestuale))
      this.fetchQualificheUnimod(callback);
    } 
    else if (isFromUnimodweb(redirectPath)) {
      this.tipoPratica = 'UN'
      this.esitoContestuale = false

      this.fetchQualificheUnimod(callback);
    }
    else  if (isFromPegniCertificati(redirectPath)) {      
      this.tipoPratica = 'CP'
      this.esitoContestuale = false
      this.fetchQualifichePegniCertificati(callback);
    }
    else  if (isFromCancellazioniIpoteca(redirectPath)) {      
      this.tipoPratica = 'CI'
      this.fetchQualificheComCanc(callback); //TODO: modificare
    }


    //console.log("this.tipoPratica", this.tipoPratica)
  }

  @action
fetchQualifichePegni(callback) {
  this.service.doAjax('GET', PATH_TRAMISSIONE_PEGNO_QUALIFICA_RICHIEDENTE)
    .then(response => this.manageFetchQualifiche(response, callback));
}

@action
fetchQualifichePegniCertificati(callback) {
  this.service.doAjax('GET', PATH_TRAMISSIONE_PEGNO_CERT_QUALIFICA_RICHIEDENTE)
    .then(response => this.manageFetchQualifiche(response, callback));
}

@action
fetchQualificheDuplo(callback) {
  this.service.doAjax('GET', PATH_TRAMISSIONE_DUPLO_QUALIFICA_RICHIEDENTE)
    .then(response => this.manageFetchQualifiche(response, callback));
}

@action
fetchQualificheComCanc(callback) {
  this.service.doAjax('GET', PATH_TRAMISSIONE_COM_CANC_QUALIFICA_RICHIEDENTE)
    .then(response => this.manageFetchQualifiche(response, callback, () => this.filterQualificheOnUtenzaDiLavoroCI()));
}

@action
fetchQualificheUnimod(callback) {
  this.service.doAjax('GET', PATH_TRAMISSIONE_UNIMOD_QUALIFICA_RICHIEDENTE)
    .then(response =>
      this.manageFetchQualifiche(response, callback)
    );
}


filterQualificheOnUtenzaDiLavoroCI() {
  const cfUL = this.rootStore?.userInfoStore?.userInfo?.codiceFiscaleUL;
  //console.log(JSON.stringify(this.rootStore.userInfoStore.userInfo))
  console.log("cfUL: "+ cfUL)

  console.log(JSON.stringify(this.qualifiche))


  if (cfUL) {
    console.log("faccio il filtro")
    this.qualifiche = this.qualifiche.filter(
      q => q?.ente?.codfiscEnte === cfUL
    );

    if(this.qualifiche.length === 0){
      this.utenzaDiLavoroErrataFlag = true;
    }

    
  }
}

/**
 * @param {Object} response - risposta del servizio
 * @param {Function} [callback] - callback finale
 * @param {Function} [postProcess] - funzione opzionale da eseguire dopo aver impostato this.qualifiche (es. filtri)
 */
@action
manageFetchQualifiche(response, callback, postProcess) {
  try {
    if (response?.success) {
      const result = response.result;

      // KO logico o assenza utenze
      const utenze = result?.utenze;
      const esitoOk = result?.esito?.esitoOk === true;

      if (!esitoOk || !Array.isArray(utenze) || utenze.length === 0) {
        this.qualifiche = [];
        this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_PROFILAZIONE}`);
        callback && callback(response);
        return;
      }

      // set utenze e post-process (eventuale filtro)
      this.qualifiche = utenze;
      if (typeof postProcess === 'function') postProcess();

      // decisione dopo il (possibile) filtro
      if (this.qualifiche.length === 1) {
        this.setQualifica(this.qualifiche[0]);
      } else {
        this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_PROFILAZIONE}`);
      }
    } else {
      // TODO: gestione errore tecnico (toast/log)
    }
  } finally {
    callback && callback(response);
  }
}


  @action
    async setQualifica (qualificaSelected, callback) {
    this.qualifica = {
      ...qualificaSelected
    };

    // l'initialPath e' settato durante lo startup della webapp (in app.jsx, il componentDidMount passa il path nella chiamate a fetchQualifiche)
    // se c'è un initialPath, viene anche configurato il relativo menu'
    // il menu e' configurato (e quindi diventa visibile) dopo la selezione di una qualifica, per evitare che l'utente possa navigare nell'applicazione prima di sceglierne una.
    if(this.initialPath) {
      if (isFromPegni(this.initialPath)) {
        this.rootStore.menuStore.configureFromPegni();
      }
      else if (isFromUnimodweb(this.initialPath)) {
        this.rootStore.menuStore.configureFromUnimodweb();
        this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_HOME}`)
        return 

      }
      else if ( isFromUnimodwebBB(this.initialPath)) { //commento per uscita in prod
        await this.rootStore.menuStore.configureFromUnimodweb();
        

      }
      else if(isFromRestituzioneDuplo(this.initialPath) || isFromRicevuteDuplo(this.initialPath)){
        this.rootStore.menuStore.configureFromUnimodweb();
      }
      
     else if (isFromPegniCertificati(this.initialPath)) {
        this.rootStore.menuStore.configureFromPegniCertificati();
      }
      else if (isFromCancellazioniIpoteca(this.initialPath)) {
        this.rootStore.menuStore.configureFromCancellazioniIpoteca();
      }
      
      this.routingStore.push(`${this.initialPath}`);
    
    } else {
      callback && callback(); //se non effettuo una redirect, chiamo un eventuale callback (ad esempio, per mostrare un messaggio di conferma);
    }
  }

  @action
  codiceFiscaleRiferimento() {
    let cf = '';
    if(this.qualifica){
      if(this.qualifica.collaborazioni && this.qualifica.collaborazioni.length > 0) {
        cf = this.qualifica.collaborazioni[0].identificativoReferente;
      }
    }
    return cf;
  }

  

  @action
  codFiscEnte() {
    let cf = '';
    if(this.qualifica){
      if(this.qualifica) {
        cf = this.qualifica.ente.codfiscEnte;
      }
    }
    return cf;
  }

  

  

}

export default QualificheStore;